/// <amd-module name="VSSUI/Page" />
export { Page } from "./Components/Page/Page";
export { Orientation, IPageProps } from "./Components/Page/Page.Props";
